import { __extends } from "tslib";
import classNames from 'classnames';
import React from 'react';
import ImageLoader from '../lib/ImageLoader';
import styles from './FallbackImg.scss';
var FallbackImg = /** @class */ (function (_super) {
    __extends(FallbackImg, _super);
    function FallbackImg() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { imageReady: false };
        _this.imageLoader = new ImageLoader({
            onLoad: function () {
                _this.setState({ imageReady: true });
            },
            onError: function () {
                _this.setState({ imageReady: false });
            },
        });
        return _this;
    }
    FallbackImg.prototype.componentDidMount = function () {
        if (this.props.src) {
            this.imageLoader.load(this.props.src);
        }
    };
    FallbackImg.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.src !== nextProps.src) {
            this.setState({ imageReady: false });
            this.imageLoader.load(nextProps.src);
        }
    };
    FallbackImg.prototype.componentWillUnmount = function () {
        this.imageLoader.unsubscribe();
    };
    FallbackImg.prototype.render = function () {
        var _a = this.props, placeholder = _a.placeholder, src = _a.src, label = _a.label, className = _a.className;
        return this.state.imageReady ? (React.createElement("div", { className: classNames(styles.image, className), style: { backgroundImage: "url(".concat(src, ")") }, role: "img", "aria-label": label })) : (React.createElement("div", { className: classNames(styles.placeholder, className) }, placeholder));
    };
    FallbackImg.defaultProps = {
        placeholder: null,
    };
    return FallbackImg;
}(React.Component));
export default FallbackImg;
//# sourceMappingURL=FallbackImg.js.map